"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Terra = void 0;
const Colony_1 = require("../../../colonies/Colony");
const ColonyName_1 = require("../../../colonies/ColonyName");
const ColonyBenefit_1 = require("../../../colonies/ColonyBenefit");
class Terra extends Colony_1.Colony {
    constructor() {
        super(...arguments);
        this.name = ColonyName_1.ColonyName.TERRA;
        this.description = 'World Government';
        this.buildType = ColonyBenefit_1.ColonyBenefit.DRAW_EARTH_CARD;
        this.tradeType = ColonyBenefit_1.ColonyBenefit.WGT_RAISE_GLOBAL_PARAMETER;
        this.tradeQuantity = [0, 0, 0, 1, 1, 2, 2];
        this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_MC_FOR_EARTH_TAGS;
        this.shouldIncreaseTrack = Colony_1.ShouldIncreaseTrack.ASK;
        this.details = [
            'Draw an Earth card',
            'WGT raises indicated global parameter',
            'Gain 1 M€ per 3 Earth tags in play',
        ];
    }
}
exports.Terra = Terra;
//# sourceMappingURL=Terra.js.map